function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadiusonesideBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14447"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 5526",
    style: {
      fill: "#f3f3f3",
      stroke: "#ebebeb"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14131"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Final - Outline",
    d: "M7.75-.25h2.16a2.262 2.262 0 0 1 2.16 2.35v2.346h-.96V2.1A1.288 1.288 0 0 0 9.91.8H7.75zm2.16.522z",
    transform: "translate(5.93 6.25)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Final - Outline",
    d: "M7.75 4.446h2.16A2.262 2.262 0 0 0 12.07 2.1V-.25h-.96V2.1a1.288 1.288 0 0 1-1.2 1.3H7.75zm2.16-.522z",
    transform: "translate(5.93 13.555)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Final - Outline",
    d: "M9.91-.25h2.16V.793H9.91a1.288 1.288 0 0 0-1.2 1.3v2.353h-.96V2.1A2.262 2.262 0 0 1 9.91-.25zm1.68.522z",
    transform: "translate(-1.75 6.25)",
    style: {
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Final - Outline",
    d: "M9.91 4.446h2.16V3.4H9.91a1.288 1.288 0 0 1-1.2-1.3V-.25h-.96V2.1a2.262 2.262 0 0 0 2.16 2.346zm1.68-.522z",
    transform: "translate(-1.75 13.555)",
    style: {
      fill: "#231f20"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiusonesideBlack);
export default __webpack_public_path__ + "static/media/RadiusonesideBlack.0beca4d496371de1454630524aa415bc.svg";
export { ForwardRef as ReactComponent };